import { PlusCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { ClearFiltersButton } from '@/components/legacy-ui/ClearFiltersButton';
import { cn } from '@/utils/classname';

import { SignalKey } from './types';
import { SIGNAL_DEFS } from './webpageSignals';

interface SitemapFilterChipsProps {
  active: Set<SignalKey>;
  onToggle: (key: SignalKey) => void;
  onClear: () => void;
}

/**
 * The five boolean signal toggle chips (Secrets, Login, SSO, Screenshots,
 * Response) styled with the FilterDropdown chip tokens, plus a Clear Filters
 * button when any are active. Rendered inside `TableControlsContainer.filters`.
 */
export const SitemapFilterChips: React.FC<SitemapFilterChipsProps> = ({
  active,
  onToggle,
  onClear,
}) => (
  <>
    {SIGNAL_DEFS.map(def => {
      const isActive = active.has(def.key);
      return (
        <button
          key={def.key}
          type="button"
          aria-pressed={isActive}
          onClick={() => onToggle(def.key)}
          className={cn(
            'flex items-center gap-1 rounded-full border px-2 py-1 text-xs font-bold',
            isActive
              ? 'border-chariot-brand-primary bg-chariot-background-secondary text-chariot-text-primary'
              : 'border-chariot-stroke text-chariot-text-secondary border-dashed'
          )}
        >
          {isActive ? (
            <XCircleIcon className="size-4" />
          ) : (
            <PlusCircleIcon className="size-4" />
          )}
          {def.label}
        </button>
      );
    })}
    {active.size > 0 && <ClearFiltersButton onClick={onClear} />}
  </>
);
